import PropTypes from "prop-types";
import styled from "styled-components/macro";

const ContainerUI = styled.ul`
  display: grid;
  gap: ${(props) => props.theme.spacing.md};
  grid-template-columns: repeat(3, 1fr);
  padding: 0;

  @media (max-width: ${(props) => props.theme.breakPoint.large}) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: ${(props) => props.theme.breakPoint.mobile}) {
    grid-template-columns: 1fr;
  }

  //=> for animation fade in and out
  transition: opacity 0.3s;
  opacity: ${(props) => {
    if (props.animateOut) {
      return 0;
    }
    if (props.animateIn) {
      return 1;
    }
  }};
`;

export default function ResourceCard({ children, ...props }) {
  return <ContainerUI {...props}>{children}</ContainerUI>;
}

ResourceCard.propTypes = {
  children: PropTypes.any.isRequired,
};
